import * as CONST from 'Reducers/Location/const'

/**
 * Get location by id
 *
 * @param locationId
 * @returns {{type, locationId: *}}
 */
export function getLocationById(locationId) {
  return {
    type: CONST.GET_LOCATION_BY_ID,
    locationId,
  }
}

/**
 * Update location by id
 *
 * @param callbacks
 * @param locationId
 * @param payload
 * @returns {{type, callbacks: *, locationId: *, payload: *}}
 */
export function updateLocationById(callbacks, locationId, payload) {
  return {
    type: CONST.UPDATE_LOCATION_BY_ID,
    callbacks,
    locationId,
    payload,
  }
}

/**
 * Create location
 *
 * @param callbacks
 * @param cityId
 * @param payload
 * @returns {{type, callbacks: *, cityId: *, payload: *}}
 */
export function createLocation(callbacks, cityId, payload) {
  return {
    type: CONST.CREATE_LOCATION,
    callbacks,
    cityId,
    payload,
  }
}

/**
 * Clear location by id
 *
 * @returns {{type}}
 */
export function clearLocationById() {
  return {
    type: CONST.CLEAR_LOCATION_BY_ID,
  }
}

/**
 * Get locations by city id
 *
 * @param cityId
 * @param includeInactive
 * @returns {{type, cityId: *, includeInactive: boolean}}
 */
export function getLocationsByCityId(cityId, includesInactive = false) {
  return {
    type: CONST.GET_LOCATIONS_BY_CITY_ID,
    cityId,
    includesInactive,
  }
}

/**
 * Clear locations by city id
 *
 * @returns {{type}}
 */
export function clearLocationsByCityId() {
  return {
    type: CONST.CLEAR_LOCATIONS_BY_CITY_ID,
  }
}

/**
 * Set locations by city id search value
 *
 * @param searchValue
 * @returns {{type, locationsByCityIdSearchValue: *}}
 */
export function setLocationsByCityIdSearchValue(searchValue) {
  return {
    type: CONST.SET_LOCATIONS_BY_CITY_ID_SEARCH_VALUE,
    locationsByCityIdSearchValue: searchValue,
  }
}

/**
 * Set locations by city id sort by
 *
 * @param sortBy
 * @returns {{type, sortBy: *}}
 */
export function setLocationsByCityIdSortBy(sortBy) {
  return {
    type: CONST.SET_LOCATIONS_BY_CITY_ID_SORT_BY,
    locationsByCityIdSortBy: sortBy,
  }
}

/**
 * Set locations by city id list status filter
 *
 * @param status
 * @returns {{type, locationsByCityIdStatusFilter: *}}
 */
export function setLocationsByCityIdStatusFilter(status) {
  return {
    type: CONST.SET_LOCATIONS_BY_CITY_ID_FILTER_STATUS,
    locationsByCityIdStatusFilter:
      CONST.LOCATION_STATUS.indexOf(status) > -1
        ? status
        : CONST.LOCATION_STATUS[1],
  }
}

/**
 * Get location types
 *
 * @returns {{type}}
 */
export function getLocationTypes() {
  return {
    type: CONST.GET_LOCATION_TYPES,
  }
}

/**
 * Archive location by location id
 *
 * @param callbacks
 * @param id
 * @returns {{type, callbacks: *, id: *}}
 */
export function archiveLocation(callbacks, id) {
  return {
    type: CONST.ARCHIVE_LOCATION,
    callbacks,
    id,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Location/actions.js